/* eslint-disable no-unused-vars */
import { Typography } from "@mui/material";
import PSettingsCard from "../../components/pos/PSettingsCard.jsx";
import PText from "../../components/pos/PText";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function StoreSettings(props) {
  const { t } = useTranslation();
  const translate = t;
  const [liveValidation, setLiveValidation] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [emailPassword, setEmailPassword] = useState("");
  const [emailPasswordError, setEmailPasswordError] = useState("");
  const [emailHost, setEmailHost] = useState("");
  const [emailHostError, setEmailHostError] = useState("");
  const [emailPort, setEmailPort] = useState("");
  const [emailPortError, setEmailPortError] = useState("");

  const [storeName, setStoreName] = useState("");
  const [storeNameError, setStoreNameError] = useState("");

  const [storeDetails1, setStoreDetails1] = useState("");
  const [storeDetails1Error, setStoreDetails1Error] = useState("");

  const [storeDetails2, setStoreDetails2] = useState("");
  const [storeDetails2Error, setStoreDetails2Error] = useState("");

  const [address1, setAddress1] = useState("");
  const [address1Error, setAddress1Error] = useState("");

  const [address2, setAddress2] = useState("");
  const [address2Error, setAddress2Error] = useState("");

  const [trn, setTrn] = useState("");
  const [trnError, setTrnError] = useState("");

  const content = (
    <table width="100%">
      <tbody>
        <tr>
          <td>
            <Typography variant="body1">{translate("Store Name")}</Typography>
          </td>
          <td width={400}>
            <PText
              type={"text"}
              InputProps={{ readOnly: true }}
              value={storeName}
              error={storeNameError}
              onChange={(e) => setStoreName(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">{translate("Store Email")}</Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={email}
              error={emailError}
              onChange={(e) => setEmail(e.target.value)}
            ></PText>
          </td>
        </tr>{" "}
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Email Password")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"password"}
              value={emailPassword}
              error={emailPasswordError}
              onChange={(e) => setEmailPassword(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">{translate("Email Host")}</Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={emailHost}
              error={emailHostError}
              onChange={(e) => setEmailHost(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">{translate("Email Port")}</Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={emailPort}
              error={emailPortError}
              onChange={(e) => setEmailPort(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Store Details ")}{" "}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={storeDetails1}
              error={storeDetails1Error}
              onChange={(e) => setStoreDetails1(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Store Details")}{" "}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={storeDetails2}
              error={storeDetails2Error}
              onChange={(e) => setStoreDetails2(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">{translate("Adddress1")} </Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={address1}
              error={address1Error}
              onChange={(e) => setAddress1(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">{translate("Adddress2")} </Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={address2}
              error={address2Error}
              onChange={(e) => setAddress2(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">{translate("TRN")} </Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={trn}
              error={trnError}
              onChange={(e) => setTrn(e.target.value)}
            ></PText>
          </td>
        </tr>
      </tbody>
    </table>
  );

  function validate() {
    setLiveValidation(true);
    return true;
  }

  function createPayload(payload) {
    payload["email"] = email;
    payload["emailPassword"] = emailPassword;
    payload["emailHost"] = emailHost;
    payload["emailPort"] = emailPort;
    payload["storeName"] = storeName;
    payload["storeDetails1"] = storeDetails1;
    payload["storeDetails2"] = storeDetails2;
    payload["address1"] = address1;
    payload["address2"] = address2;
    payload["trn"] = trn;
  }

  function populateObject(bean) {
    console.log("POPULATE");
    setEmail(bean.email);
    setEmailPassword(bean.emailPassword);
    setEmailHost(bean.emailHost);
    setEmailPort(bean.emailPort);
    setStoreName(bean.storeName);
    setStoreDetails1(bean.storeDetails1);
    setStoreDetails2(bean.storeDetails2);
    setAddress1(bean.address1);
    setAddress2(bean.address2);
    setTrn(bean.trn);
  }

  return (
    <PSettingsCard
      avatar="S"
      title={translate("Store Settings")}
      cardContent={content}
      onValidate={validate}
      createPayload={createPayload}
      populateObject={populateObject}
      messagHandler={props.messagHandler}
      settingKey="email"
    ></PSettingsCard>
  );
}
